import { createFileRoute } from "@tanstack/react-router";
import { PrjTmplEditPage } from "@client/components/workflow-tmpl/prj-tmpl-edit-page";

export const Route = createFileRoute(
  "/_app/projects/templates/$templateId",
)({
  component: PrjTmplEditRoute,
});

function PrjTmplEditRoute() {
  const { templateId } = Route.useParams();
  return <PrjTmplEditPage templateId={templateId} />;
}
